import * as HLF from "html-living-framework";
import { LayoutButton } from "GameObjects/UI/LayoutButton";
import { Sine, TimelineLite, TweenLite, TweenMax } from "gsap";

export class RestStopGraphTypeToggleButton extends LayoutButton {
    public simulateClick(): void {
        // intentionally not calling super.simulateClick()
        const clickTimeline: TimelineLite = new TimelineLite();
        clickTimeline.call(this.scaleDown, undefined, this, 0);
        clickTimeline.call(this.enableOutline, undefined, this, 0);
        clickTimeline.call(() => {
            if (this.interactive) {
                this.disableOutline();
                this.scaleNormal();
            }
            else {
                this.enableOutline();
                this.scaleDisabled();
            }
        }, undefined, this, 0.15);
    }

    public setInteractive(pInteractive: boolean) {
        super.setInteractive(pInteractive);
        if (pInteractive === false) {
            this.enableOutline();
            this.scaleDisabled();
        }
        else {
            this.disableOutline();
            this.scaleNormal();
        }
    }

    public onFocusEnd(): void {
        super.onFocusEnd();
        if (!this.interactive) {
            this.enableOutline();
        }
    }

    protected tintDisabled() {
        // intentionally not calling super.tintDisabled()
    }

    protected onPointerUp(pEvent: PIXI.InteractionEvent): void {
        super.onPointerUp(pEvent);
        if (!this.interactive) {
            this.enableOutline();
        }
    }

    protected scaleDisabled() {
        TweenMax.to(this._visuals.scale, 0.15, {
            x: LayoutButton.SCALE_NORMAL * 1.1,
            y: LayoutButton.SCALE_NORMAL * 1.1,
            ease: Sine.easeInOut,
        });
    }

}